<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage " style="    margin-bottom: 85px;">
         <!-- navbar -->
         <div class="homepage-navbar bg-primary shadow p-3">
            <div class="d-flex align-items-center">
         
               <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;
                  
                  <span>
                     <h4 class="text-white">{{language?.Room_Booking}}</h4>
                  </span>
        
            </div>
            



         </div>
    
       
      
<div class="card">
  <div class="card-header">
    <h6 class="mb-0">{{ language?.Room_Booking }} <span class="badge bg-danger">{{  room_details.roomno }} </span></h6>
  </div>

  <div class="card-body">
    <div class="col-12">
      <div class="row">
        <div class="col-6">
    <div class="">
      <label for="fromDate" class="form-label">{{ language?.check_in }}</label>
      <input 
        type="datetime-local" 
        id="fromDate" 
        v-model="roombooking.fromdate" @change="calculatecost()"
        class="form-control" 
        required
      >
    </div>
    </div>

     <div class="col-6">

    <div class="">
      <label for="toDate" class="form-label">{{ language?.check_out }}</label>
      <input 
        type="datetime-local" 
        id="toDate" 
        v-model="roombooking.todate" @change="calculatecost()"
        class="form-control" 
        required
      >
    </div>
    </div>

    </div>
    </div>

  
  </div>
</div>




<div class="card">
  <div class="card-body">

    <h4 class="text-danger"> Customer Details</h4>

    <div class="form customer_card" v-for="(customer, index) in customers" :key="index">
      

            <div class="">
                        <label for="mobile" class="form-label">{{ language?.customer_name }}</label>
                        <input type="text" id="mobile" v-model="customer.name" class="form-control" required>
                    </div>
                     <div class="col-12 row">
                          <div class="col-8">
                            <label for="mobile" class="form-label">{{ language?.customer_contact }}</label>
                            <input type="number" id="mobile" v-model="customer.contactno" class="form-control" @input="getcustdeatils(customer,index)" required>
                        </div>
                              <div class="col-4">
                            <label for="mobile" class="form-label">{{ language?.customer_age }}</label>
                            <input type="number" id="mobile" v-model="customer.age" class="form-control" required>
                        </div>
                      </div>
                        <div class="col-12 row">
                          <div class="col-6">
                        <label for="mobile" class="form-label">{{ language?.identity_proof }}</label>
                        <input type="text" id="mobile" v-model="customer.identity" class="form-control" required>
                    </div>
                        <div class="col-6">
                                <label for="gender" class="form-label">{{ language?.gender }}</label>
                                <select id="gender" v-model="customer.gender" class="form-control" required>
                                  <option disabled value="">-- Select --</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                </select>
                              </div>

                    </div>
                     <div class="col-12 row"> 
                   <div class="col-6">
                                <label class="col-form-label" >{{ language?.identity_photo }}</label> 
                                <template v-if="customer?.identityphoto">
                                    <img   
                                      :src="'https://hotelstay.dktsoft.in/writable/uploads/customeridproof/'+customer.identityphoto"  
                                      alt="Uploaded Image" 
                                      style="height: 80px; width: 80px; object-fit: cover; border: 1px solid #ccc;"
                                    />
                                </template>

                                <template v-else>
                                <input class="form-control" type="file"  @change="handleFileUpload($event,customer)"  ref="fileInput"    accept="image/*" capture="environment" 
                                    required=""  ><br>
                                    <!-- <img :src=" imageUrls ?imageUrls: this.$hostname+'/writable/visitors/user.png'"  @click="triggerFileInput" alt="Uploaded Image" style="height: 80px; width: 80px;" /> -->

                                 <img 
                                      v-if="customer.identityphotoPreview" 
                                      :src="customer.identityphotoPreview"  
                                      alt="Uploaded Image" 
                                      style="height: 80px; width: 80px; object-fit: cover; border: 1px solid #ccc;"
                                    />

                                </template>




                             
                            </div>
                           <div class="col-6">
                                <label class="col-form-label" >{{ language?.customer_photo }}</label> 
                                <input class="form-control" type="file"  @change="customerphotoUpload($event,customer)"  ref="fileInput"   accept="image/*" capture="environment"  
                                    required=""  ><br>
                                    <!-- <img :src=" imageUrls ?imageUrls: this.$hostname+'/writable/visitors/user.png'"  @click="triggerFileInput" alt="Uploaded Image" style="height: 80px; width: 80px;" /> -->
                                      <img 
                                      v-if="customer.customerphotoPreview" 
                                      :src="customer.customerphotoPreview"  
                                      alt="Uploaded Image" 
                                      style="height: 80px; width: 80px; object-fit: cover; border: 1px solid #ccc;"
                                    />
                             
                            </div>

                        </div> 


                          <div class="col-12">
                            <label for="mobile" class="form-label">{{ language?.customer_address }}</label>
                            <input type="text" id="mobile" v-model="customer.address" class="form-control" required>
                        </div>



                    <div class="col-12">
                      <div class="row">
                         <div class="col-6">
                           <button  class="btn btn-success w-100" @click="addCustomer">+ Add New Member</button>
                          </div> 
                          <div class="col-6" v-if="index !== 0">
                             <button  class="btn btn-danger w-100" @click="removeCustomer">Remove</button>
                            </div>
                        </div>
                      </div>

                      </div>
        


    <!-- </div>  -->

  </div>
  </div>


  <div class="card">
  <div class ="card-body">

    <div class="col-12">
      <div class="row">
        <div class="col-6">

      <label for="mobile" class="form-label">{{ language?.ispaid }}</label>&nbsp;
       <input type="text" id="mobile" v-model="roombooking.paidamt" class="form-control" required>
        </div>
                <div class="col-6">

    <div class="">
                        <label for="mobile" class="form-label">{{ language?.payment_type }}</label>
                        <select id="roomtype" v-model="roombooking.paymentstatus" class="form-control" required>
                            <option value="">Select Payment Type</option>
                            <option value="Cash">Cash</option>
                            <option value="Upi">Upi</option>
                            <option value="CreaditCard">Credit Card</option>
                            <option value="DebitCard">Debit Card</option>
                        </select>
                    </div>
                    </div>

                    </div>
                    </div>

        
                            <span class="text-danger mt-4">
                          Due Amount : {{ Math.max(room_details.cost - roombooking.paidamt, 0) }}
                        </span>




       <div class="">
                        <label for="mobile" class="form-label">{{ language?.note }}</label>
                        <input type="text" id="mobile" v-model="roombooking.note" class="form-control" required>
                    </div>

  </div>

  </div>













<div class="card footer_card">
  <div class="card-body">
    <div class="col-12 row">
      <div class="col-6">
    <span class="text-danger"><strong>Cost : {{ room_details.cost }}</strong></span>
    </div>
    <div class="col-6">
      <div class="">
      <label for="fromDate" class="form-label">{{ language?.exact_check_in }}</label>
      <input 
        type="time" 
        id="fromDate" 
        v-model="roombooking.exactchecking" @change="calculatecost()"
        class="form-control" 
        required
      >
    </div>
    </div>
    </div>
    </div>
      <button class="btn btn-primary w-100 " @click="saveroombooking">Save</button>
  </div>













      </div>
    </div>
</template>

<style scoped>
.bg_card {
    background: #ededec;
    margin: 10px 0px;
    padding-bottom: 28px;
    padding: 10px;
}
.form-label{
  margin-bottom: 0px;
}
.footer_card{
      list-style: lower-greek;
    position: fixed;
    background: #d7ffdb;
    bottom: 0;
    width: -webkit-fill-available;
 
}

.customer_card{
      padding: 5px;
    border: 1px solid;
    border-radius: 10px;
}
</style>
  
<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
    
    if (this.$route.query.q) {

            let roomid=this.$route.query.q;
            let bookid=this.$route.query?.bookid;
            this.getBranches(roomid,bookid);
            
        }
        else{
         
           this.getBranches();
        }







},
  data() {
const today = new Date().toISOString().slice(0,16);
const nextdate = new Date(Date.now() + 86400000).toISOString().slice(0,16);


    return { 
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
       imageUrls: null,
       custimageUrls:null,
      language: this.getLocalStorageArray('lang'),

  
      customers: [
          {
            name: '',
            contactno: '',
            identity: '',
            identityphoto: '',
            customerphoto: '',      
            age: '',
            address: '',
            gender:''
          }
        ],
        savedCustomers:[],




      roombooking:{
        fromdate:today,
        todate:nextdate,
        paymentstatus:'',
        paidamt:'',
        note:'',
        exactchecking:''



      },
      room_details:[], 
      roomcatlist:[],
      branch_name:''

    }
  },
  methods:{
    initializeHomeContent(){
    

    },
    goBack() {
          
          this.$router.go(-1);
  },
  goprevious() {
          
          this.$router.go("/branch");
  },

 
  
    async getBranches(roomid,bookingid) {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getroombooking",{id:roomid,bookingid:bookingid}).then((response) => {
             
               self.room_details=response.data.room_details;
            



               self.booking_customer_details=response.data.booking_customer_details;






               if(self.booking_customer_details){

                   self.roombooking=response.data.booking_details;
       
                self.customers[0].name=response.data.booking_customer_details.cust_name;
                self.customers[0].contactno=response.data.booking_customer_details.cust_contact;
                self.customers[0].age=response.data.booking_customer_details.cust_age;
                self.customers[0].identityphoto=response.data.booking_customer_details.cust_identityphoto;
                self.customers[0].customerphoto=response.data.booking_customer_details.cust_customerphoto;
                self.customers[0].address=response.data.booking_customer_details.cust_address;
                self.customers[0].gender=response.data.booking_customer_details.cust_gender;
                self.customers[0].identity=response.data.booking_customer_details.cust_identity;
               }
            
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 





      //  savecustomer() {
      //   this.loading = true;
      //   this.error = null;
  
      //   try {
      //      var self=this;
      //       axios.post("addroom",self.room).then((response) => {
              
      //                   self.room_details=response.data.room_details;
      //                   self.language=response.data.language;
      //                self.$swal.fire(response.data.message);
      //                if(response.data.success)
      //                {
      //                   self.branch={ name:'',         address:'',contact:'',};
      //                }
      //                window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                      

               
        
      //     }).then(() => {
      //          self.initializeHomeContent();
      //     }).catch((err) => {
            
      //     });;
         

      //   } catch (err) {
      //     this.error = err.response?.data?.message || "Login failed. Please try again.";
      //   } finally {
      //     this.loading = false;
      //   }
      // }, 



      //     savecustomer(index) {
      //    this.savedCustomers.push({ ...this.customers[index] });
      //    alert("Customer Saved");
      // }, 







 

             handleFileUpload(event,customer) {
                  const file = event.target.files[0];
                  customer.identityphoto = file;

                  if (file) {
                    this.imageUrls = URL.createObjectURL(file);
                     customer.identityphotoPreview = URL.createObjectURL(file);
                  }
                },

                  customerphotoUpload(event,customer) {
                  const file = event.target.files[0];
                  customer.customerphoto = file;

                  if (file) {
                    this.custimageUrls = URL.createObjectURL(file);
                     customer.customerphotoPreview = URL.createObjectURL(file);
                  }
                },
     getLocalStorageArray(key) {
                let data = localStorage?.getItem(key);
                try {
                    return data ? JSON.parse(data) : [];
                } catch (e) {
                    console.error("Error parsing localStorage data", e);
                    return [];
                }
            },
                
                 addCustomer() {
                            this.customers.push({   
                              name: '',
                              contactno: '',
                              identity: '',
                              identityphoto: '',
                              identityphotoPreview: '',
                              customerphoto: '',
                              customerphotoPreview: '',
                              age: '',
                              address: '',
                              gender:'',

                            });

                            console.log("customeradded"+this.customers);

                          },




                          saveroombooking() {
                      this.loading = true;
                      this.error = null;
                    
                      try {
                        var self=this;

                        if(self.roombooking.fromdate == ''){
                      
                           self.$swal.fire("Enter Checkin Date");
                        }
                        
                        else if(self.customers[0].name == ''){
                          

                           self.$swal.fire("Enter Customer Name");

                        }else{



                          axios.post("saveroombooking",{
                                    roomdetails: self.room_details, 
                                    bookingdetails: self.roombooking,
                                    customers:self.customers
                                },
                              {headers: {
               'Content-Type': 'multipart/form-data' 
          }}).then((response) => {
                            
                                      self.room_details=response.data.room_details;
                                      self.language=response.data.language;
                                      self.$swal.fire(response.data.message);
                                      if(response.data.success)
                                      {
                                        
                                          self.branch={ name:'',         address:'',contact:'',};

                                          self.$router.push('/roomview')
                                      }
                                  window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                                    

                            
                      
                        }).then(() => {
                            self.initializeHomeContent();
                        }).catch((err) => {
                          
                        });;
                      }
                      

                      } catch (err) {
                        this.error = err.response?.data?.message || "Login failed. Please try again.";
                      } finally {
                        this.loading = false;
                      }
                    }, 

                    removeCustomer(index) {
                        this.customers.splice(index, 1);
                    },


                  calculatecost() {
                        const fromdate = this.roombooking.fromdate;
                        const todate = this.roombooking.todate;

                        if (fromdate && todate) {
                          const start = new Date(fromdate);
                          const end = new Date(todate);

                          // Difference in days
                          const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

                          // Cost calculation — using existing room cost as per-day cost
                          const perDayCost = this.room_details.cost || 0;
                          const totalCost = diffDays * perDayCost;

                          // Update room_details.cost
                          this.room_details.cost = totalCost;

                          console.log(`Days: ${diffDays}, Updated Cost: ${totalCost}`);
                        } else {
                          this.room_details.cost = 0;
                        }
                      },



                    
         async getcustdeatils(customer,index) {
    try {
      // alert(contactno);return;
   
      // let formData = new FormData();
      // formData.append("contactno", this.customer.contactno);
      if(customer.contactno.toString().length!=10)
      return;

      const response = await axios.post("getcustdeatils", {"contactno":  customer.contactno});
     customer = response.data.cust_details;
      this.customers[index]=response.data.cust_details;

        //   this.customers[index] = {
        //   ...this.customers[index], // Keep all existing properties
        //   name: cust_details.name || this.customers[index].name,
        //   contactno: cust_details.contactno || this.customers[index].contactno,
        //   identity: cust_details.identity || this.customers[index].identity,
        //   age: cust_details.age || this.customers[index].age,
        //   address: cust_details.address || this.customers[index].address,
        //   gender: cust_details.gender || this.customers[index].gender,
        //   // Don't overwrite these photo-related fields
        //   identityphoto: this.customers[index].identityphoto,
        //   identityphotoPreview: this.customers[index].identityphotoPreview,
        //   customerphoto: this.customers[index].customerphoto,
        //   customerphotoPreview: this.customers[index].customerphotoPreview
        // };

  

    } catch (err) {
      console.error("API Error:", err);
    }
  }

















  }
}






</script>
